// src/pages/Login.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as z from 'zod';

import { AuthLayout } from '../components/AuthLayout';
import { Button } from 'components/Elements';
import { Form, InputField } from 'components/Form';
import { useAuth } from 'lib/auth';

const schema = z.object({
  email: z.string().email('Enter a valid email').min(1, 'Email is required'),
  password: z.string().min(1, 'Password is required'),
});

export function Login() {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const navigate = useNavigate();

  return (
    <AuthLayout title="Login" subtitle="Welcome back to Ayinza Home">
      <Form
        onSubmit={async (values) => {
          setLoading(true);
          try {
            await login({
              email: values.email,
              password: values.password,
            });
            navigate('/products');
          } catch (error) {
            setLoading(false);
          }
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="email"
              label="Email"
              error={formState.errors['email']}
              registration={register('email')}
              placeholder="you@example.com"
            />

            <InputField
              type="password"
              label="Password"
              error={formState.errors['password']}
              registration={register('password')}
              placeholder="••••••••"
            />

            <Button isLoading={loading} type="submit" className="w-full">
              Login
            </Button>
          </>
        )}
      </Form>

      <div className="text-center mt-3 text-sm text-[#AC3F1E]">
        <Link to="/account/forgot-password">Forgot password?</Link>
      </div>
    </AuthLayout>
  );
}

Login.propTypes = {
  onSuccess: PropTypes.func,
};
